import './explore.scss';
import 'mapbox-gl/dist/mapbox-gl.css';
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Container, ListGroup, Button, Card } from "react-bootstrap";
import PropTypes from "prop-types";
import Map, {Marker, GeolocateControl, ScaleControl, NavigationControl, Popup} from 'react-map-gl';
import mapboxgl from 'mapbox-gl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import mapAPI from '../../common/mapApi';
import { withRouter } from "react-router-dom";
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css'
import Geocoder from 'react-map-gl-geocoder'

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

// TODO: Store this as environment variable
const MAPBOX_TOKEN = 'pk.eyJ1IjoiY29uZ2RvZSIsImEiOiJja205NmhqY2UxZXpuMnVwbTV0dDFvZjh4In0.aadaTJC6ZbASBxqpX8Il3A';

const geolocateControlStyle= {
    right: 10,
    top: 80
};

const scaleControlStyle= {
    left: 20,
    bottom: 100
};

const navControlStyle= {
    right: 10,
    top: 120
};

function ExplorePage(props) {
    const [search, setSearch] = useState("");
    const [showPopup, togglePopup] = useState(false);
    const [mapStyle, setMapStyle] = useState("mapbox://styles/congdoe/ckmxmhljb0z7918mrmvrro060")
    const [searchResults, setSearchResults] = useState(null);
    const [marker, setMarker] = useState(null);
    const [currentLocation, setCurrentLocation] = useState({latitude: null, longitude: null});
    const [viewport, setViewport] = useState(null);

    useEffect(() => {
        const currTime = (new Date()).getHours();
        console.log("TIME: ", currTime)
        if (!(currTime > 6 && currTime < 18 )){
            setMapStyle("mapbox://styles/congdoe/ckmxn4ko50zv917pduviuis4w");
        }
    },[]);

    useEffect(() => {
        const fetchSearch = async () => {
            if (search === ""){
                setSearchResults(null);
                return;
            }
            try {
                var { data } = await mapAPI.getAutoSearch(search, currentLocation.longitude+","+currentLocation.latitude);
            } catch (error) {
                console.log("Error getting search results : ", JSON.stringify(error));
            }
            setSearchResults(data);   
        }
        fetchSearch();
        console.log("Search text: ", search);
    }, [search]);


    const mapRef = useRef();
    
const handleViewportChange = useCallback(
    (newViewport) => setViewport(newViewport),
    []
);

const getSelectedResult = useCallback((search) => {
    console.log("Spot: ", search.result);
    setMarker(search.result);
    togglePopup(true);
},[]);

const getLocation = useCallback((location) => {
    setCurrentLocation(location.coords);
},[]);

const selectSpot = async (result) => {

    console.log("MAPBOX DATA: ", JSON.stringify(result));
    setViewport({
        longitude: result.center[0],
        latitude: result.center[1],
        zoom: 14,
        bearing: 0,
        pitch: 0
    });
    setMarker({
        longitude: result.center[0],
        latitude: result.center[1],
    });
    setSearch("");
}

const handleSaveSpotClick = useCallback(
    (marker) => {
        props.setSelectedMarker(marker);
        props.history.push("/createRecommendation")   
    }
,[]
); 

const renderSelectedMarker = () => {
    if(marker){
        return (
            <Marker latitude={marker.center[1]} longitude={marker.center[0]} offsetLeft={-12} offsetTop={-30}>
                <FontAwesomeIcon onClick={() => togglePopup(!showPopup)} className='text-primary fa-2x' icon={faMapMarkerAlt} />
            </Marker>
        );
    } 
    return
}

const renderMapSpotOptions = (marker) => {
    return (
        <>
        <Button className="p-0 px-1 mr-1" size="sm">Foursquare</Button>
        <Button className="p-0 px-1 mr-1" onClick={() => handleSaveSpotClick(marker)} size="sm">Save</Button>
        <Button className="p-0 px-1 mr-1" size="sm">Share</Button>
        </>
    );
}

const renderSearch = () => {

    if (searchResults){
        if (Array.isArray(searchResults.features)) {
            const results = searchResults.features.map(result => {
                return (
                    <ListGroup.Item
                    className="p-2"
                    onClick={async () => selectSpot(result)}
                    >
                        {result.text}
                        <p className="place-text text-secondary mb-0">{result.place_name}</p>
                    </ListGroup.Item>
                );
            });
            return results;
        }
    }
}

    return (
      <Container className="m-0 p-0">
        <Map
            ref={mapRef}
            {...viewport}
            width="100%"
            height="100vh"
            mapStyle={mapStyle}
            onViewportChange={viewport => setViewport(viewport)}
            mapboxApiAccessToken={MAPBOX_TOKEN}
            // className="full-width"
        >
        {showPopup && <Popup
          latitude={marker.center[1]}
          longitude={marker.center[0]}
          closeButton={true}
          closeOnClick={false}
          onClose={() => togglePopup(false)}
          anchor="bottom" 
          offsetLeft={0}
          offsetTop={-30}
          className="map-card"
          >

          <Container className="map-card">
              <Card className="p-0 map-card" style={{ width: '18rem' }}>
                <Card.Body className="p-2 map-card">
                <Card.Title>
                {marker.text}
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">{marker.context[2].text}</Card.Subtitle>
                <Card.Text>
                <small>{marker.place_name}</small>
                </Card.Text>
            <Card.Link>{renderMapSpotOptions(marker)}</Card.Link>
        </Card.Body>
        </Card></Container>
        </Popup>}
        <GeolocateControl
            style={geolocateControlStyle}
            positionOptions={{enableHighAccuracy: true}}
            trackUserLocation={false}
            onGeolocate={getLocation}
            auto
        />
        <ScaleControl maxWidth={100} unit="imperial" style={scaleControlStyle} />
        <NavigationControl style={navControlStyle} />
        <Geocoder
          mapRef={mapRef}
          onViewportChange={handleViewportChange}
          marker={false}
          mapboxApiAccessToken={MAPBOX_TOKEN}
          minLength={2}
          onResult={getSelectedResult}
          proximity={currentLocation}
          className="geocoder-style"
        />
            {renderSelectedMarker()}
        </Map>
      </Container>
    );
}

ExplorePage.propTypes = {
  notifyInfo: PropTypes.func.isRequired,
  notifyFailure: PropTypes.func.isRequired,
  setSelectedMarker: PropTypes.func.isRequired
};

export default withRouter(ExplorePage);
